export default __webpack_public_path__ + "static/media/elite icon blk.aed130da.svg";